export const OVERVIEW_REPORT_NAME = 'overview';
export const CUSTOM_REPORT_NAME = 'custom-report';
